import { combineReducers } from 'redux'
import thunk from 'redux-thunk'
import {
    userDeleteReducer, userListReducer,
    userLoginReducer,
    userRegisterReducer,
    userResetReducer,
    userUpdateReducer
} from './redux-components/reducers/userReducers'
import { notepadCreateReducer, notepadDeleteReducer, notepadGetReducer, notepadUpdateReducer } from './redux-components/reducers/notepadReducers'
import { shortcutCreateReducer, shortcutDeleteReducer, shortcutGetReducer, shortcutUpdateReducer } from './redux-components/reducers/shortcutReducers'
import { categoryClearReducer, categoryCreateReducer, categoryDeleteAllReducer, categoryDeleteReducer, categoryGetReducer, categoryUpdateReducer, reminderCreateReducer, reminderDeleteReducer, reminderGetReducer, reminderUpdateReducer } from './redux-components/reducers/reminderReducers'
import { editModeReducer } from './redux-components/reducers/editModeReducers'
import {
    groceryFavoritesCreateReducer, groceryFavoritesDeleteAllReducer, groceryFavoritesDeleteReducer,
    groceryFavoritesGetReducer, groceryFavoritesUpdateReducer,
    groceryItemCreateReducer, groceryItemDeleteAllReducer, groceryItemDeleteCheckedReducer, groceryItemDeleteReducer,
    groceryItemGetReducer,
    groceryItemUpdateReducer, groceryUndoListReducer
} from "./redux-components/reducers/groceryReducers";
import {
    checklistCategoryCreateReducer,
    checklistCategoryDeleteReducer,
    checklistCategoryGetReducer,
    checklistCategoryUpdateReducer,
    checklistItemCreateReducer, checklistItemDeleteReducer,
    checklistItemGetReducer,
    checklistItemUpdateReducer
} from "./redux-components/reducers/checklistReducers";
import {configureStore} from "@reduxjs/toolkit";
import { USER_LOGOUT } from './redux-components/constants/userConstants';
import {
  consoleListReducer,
  consoleDetailsReducer,
  consoleCreateReducer,
  consoleDeleteReducer,
  consoleItemListReducer,
  consoleItemDetailsReducer,
  consoleItemCreateReducer,
  consoleItemUpdateReducer,
  consoleItemDeleteReducer,
  listItemAddReducer,
  listItemUpdateReducer,
  listItemDeleteReducer,
} from './redux-components/reducers/consoleReducers';
import {
    apiKeyListReducer,
    apiKeyCreateReducer,
    apiKeyDeleteReducer,
} from './redux-components/reducers/apiKeyReducers';
import {
    groceryV2ItemGetReducer,
    groceryV2ItemCreateReducer,
    groceryV2ItemUpdateReducer,
    groceryV2ItemDeleteReducer,
    groceryV2ItemUpdateMultipleReducer,
    groceryV2CategoryGetReducer,
    groceryV2CategoryCreateReducer,
    groceryV2CategoryUpdateReducer,
    groceryV2CategoryDeleteReducer,
    groceryV2CategoryUpdateMultipleReducer,
    groceryV2ItemDeleteCheckedReducer,
    groceryV2ItemCheckReducer,
    groceryV2FavoritesGetReducer,
    groceryV2FavoritesCreateReducer,
    groceryV2FavoritesDeleteReducer,
    groceryV2UndoListReducer
} from './redux-components/reducers/groceryV2Reducers';

const reducer = combineReducers({
    editMode: editModeReducer,
    userRegister: userRegisterReducer,
    userLogin: userLoginReducer,
    userReset: userResetReducer,
    userDelete: userDeleteReducer,
    userUpdate: userUpdateReducer,
    userList: userListReducer,

    apiKeyList: apiKeyListReducer,
    apiKeyCreate: apiKeyCreateReducer,
    apiKeyDelete: apiKeyDeleteReducer,

    notepadGet: notepadGetReducer,
    notepadUpdate: notepadUpdateReducer,
    notepadCreate: notepadCreateReducer,
    notepadDelete: notepadDeleteReducer,

    shortcutGet: shortcutGetReducer,
    shortcutCreate: shortcutCreateReducer,
    shortcutUpdate: shortcutUpdateReducer,
    shortcutDelete: shortcutDeleteReducer,

    categoryGet: categoryGetReducer,
    reminderGet: reminderGetReducer,
    reminderCreate: reminderCreateReducer,
    categoryCreate: categoryCreateReducer,
    categoryUpdate: categoryUpdateReducer,
    reminderUpdate: reminderUpdateReducer,
    reminderDelete: reminderDeleteReducer,
    categoryDelete: categoryDeleteReducer,
    categoryDeleteAll: categoryDeleteAllReducer,
    reminderClear: categoryClearReducer,

    groceryItemGet: groceryItemGetReducer,
    groceryItemCreate: groceryItemCreateReducer,
    groceryItemUpdate: groceryItemUpdateReducer,
    groceryItemDelete: groceryItemDeleteReducer,
    groceryItemDeleteAll: groceryItemDeleteAllReducer,
    groceryItemDeleteChecked: groceryItemDeleteCheckedReducer,
    groceryFavoritesGet: groceryFavoritesGetReducer,
    groceryFavoritesCreate: groceryFavoritesCreateReducer,
    groceryFavoritesDelete: groceryFavoritesDeleteReducer,
    groceryFavoritesDeleteAll: groceryFavoritesDeleteAllReducer,
    groceryFavoritesUpdate: groceryFavoritesUpdateReducer,
    groceryUndoList: groceryUndoListReducer,

    checklistCategoryCreate: checklistCategoryCreateReducer,
    checklistCategoryGet: checklistCategoryGetReducer,
    checklistCategoryUpdate: checklistCategoryUpdateReducer,
    checklistCategoryDelete: checklistCategoryDeleteReducer,
    checklistItemCreate: checklistItemCreateReducer,
    checklistItemGet: checklistItemGetReducer,
    checklistItemUpdate: checklistItemUpdateReducer,
    checklistItemDelete: checklistItemDeleteReducer,

    consoleList: consoleListReducer,
    consoleDetails: consoleDetailsReducer,
    consoleCreate: consoleCreateReducer,
    consoleDelete: consoleDeleteReducer,
    consoleItemList: consoleItemListReducer,
    consoleItemDetails: consoleItemDetailsReducer,
    consoleItemCreate: consoleItemCreateReducer,
    consoleItemUpdate: consoleItemUpdateReducer,
    consoleItemDelete: consoleItemDeleteReducer,
    listItemAdd: listItemAddReducer,
    listItemUpdate: listItemUpdateReducer,
    listItemDelete: listItemDeleteReducer,

    groceryV2ItemGet: groceryV2ItemGetReducer,
    groceryV2ItemCreate: groceryV2ItemCreateReducer,
    groceryV2ItemUpdate: groceryV2ItemUpdateReducer,
    groceryV2ItemDelete: groceryV2ItemDeleteReducer,
    groceryV2ItemUpdateMultiple: groceryV2ItemUpdateMultipleReducer,
    groceryV2CategoryGet: groceryV2CategoryGetReducer,
    groceryV2CategoryCreate: groceryV2CategoryCreateReducer,
    groceryV2CategoryUpdate: groceryV2CategoryUpdateReducer,
    groceryV2CategoryDelete: groceryV2CategoryDeleteReducer,
    groceryV2CategoryUpdateMultiple: groceryV2CategoryUpdateMultipleReducer,
    groceryV2ItemDeleteChecked: groceryV2ItemDeleteCheckedReducer,
    groceryV2ItemCheck: groceryV2ItemCheckReducer,
    groceryV2FavoritesGet: groceryV2FavoritesGetReducer,
    groceryV2FavoritesCreate: groceryV2FavoritesCreateReducer,
    groceryV2FavoritesDelete: groceryV2FavoritesDeleteReducer,
    groceryV2UndoList: groceryV2UndoListReducer,
});

// Logging out has to clear every slice, not just the login one. Without this, the previous account's
// reminders, grocery list, notepads and console data sit in the store until the page is reloaded, and
// transient flags (edit mode, success markers) survive with them.
const rootReducer = (state, action) => (
    action.type === USER_LOGOUT ? reducer(undefined, action) : reducer(state, action)
);

const userInfoFromStorage = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;

const initialState = {
    userLogin: {userInfo:userInfoFromStorage},
    editMode: false,
    groceryUndoList: {
        undoList: []
    },
    groceryV2UndoList: {
        undoList: []
    }
}

const middleware = [thunk];

export default configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        ...middleware,
    }),
    devTools: process.env.NODE_ENV === "development"
})
